<script lang="ts" setup>
import { createReschedulableTimeout } from '@collector/shared-utils'

import { useTimeout } from '../composables'
import Icon from './Icon/Icon.vue'
import Tooltip from './Tooltip.vue'
import TransitionFadeOut from './transitions/TransitionFadeOut.vue'

interface Props {
  title?: string
}

defineProps<Props>()

// data
const hideTimeoutMs = 5000
const reshowTimeoutMs = 150
const { ready: shouldShow, start: reshow } = useTimeout(reshowTimeoutMs)

// methods
const { rescheduleTimeout } = createReschedulableTimeout(() => {
  shouldShow.value = false
}, hideTimeoutMs)

function show(): void {
  if (shouldShow.value) {
    shouldShow.value = false
    reshow()
  } else {
    shouldShow.value = true
  }

  rescheduleTimeout()
}

// expose
defineExpose({ show })
</script>

<template>
  <TransitionFadeOut>
    <div v-if="shouldShow">
      <Tooltip>
        <div class="text-success-2 flex items-center gap-x-1">
          <Icon
            class="h-3 w-3"
            icon="check-circle"
          />
          <span class="text-xs font-bold">
            <slot />
          </span>
        </div>
        <template
          v-if="title"
          #tooltip
        >
          {{ title }}
        </template>
      </Tooltip>
    </div>
  </TransitionFadeOut>
</template>
